<template>
    <div class="main main-padding">
        <!--基础数据-->
        <Row :gutter="10" style="margin-top: 10px;">

            <Col :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
                <div class="num-card">
                    <img src="../../../assets/images/schoolCount.png" class="num-card-img">
                    <div class="num-card-text">学校数: {{student.schoolCount}} 个</div>
                </div>
                <div class="num-card user-num-card" v-on:click="lookDataDetails()">
                    <img src="../../../assets/images/userCount.png" class="num-card-img">
                    <div class="num-card-text">学生机总数:{{student.studentCount}}人</div>
                </div>
            </Col>
            <!--学生机日活用户数-->
            <Col xs="20" :sm="20" :md="20" :lg="20" :xl="20">
                <line-charts
                    :chartsTitle="'学生机日活用户数'"
                    :chartsId="'student_day_use'"
                    :lineCompany="'人'"
                    ref="studentDayUse"
                ></line-charts>
            </Col>
        </Row>
        <Row :gutter="10" style="margin-top: 10px;">
            <!--学生机周活用户数-->
            <Col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                <line-charts
                    :chartsTitle="'学生机周活用户数'"
                    :chartsId="'student_week_use'"
                    :lineCompany="'人'"
                    ref="studentWeekUse"
                ></line-charts>
            </Col>
            <!-- 各模块使用统计-->
            <Col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                <pie-charts
                    :chartsTitle="'各模块使用统计'"
                    :isShowMore=false
                    :isClickCharts=false
                    :chartsId="'student_module_statics'"
                    :pieChartsName="'模块统计'"
                    ref="studentModuleStatics"
                ></pie-charts>
            </Col>
            <!--学生机月活用户数-->
            <Col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                <line-charts
                    :chartsTitle="'学生机月活用户数'"
                    :chartsId="'student_month_use'"
                    :lineCompany="'人'"
                    ref="studentMonthUse"
                ></line-charts>
            </Col>
        </Row>
        <!-- 各学校使用排名统计(近一个月数据) -->
        <Row :gutter="10" style="margin-top: 10px;">
            <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <div class="data-select">
                    <Select v-model="dateIndex" style="width:200px" @on-change="onChange">
                        <Option v-for="item in dateList" :value="item.value" :key="item.value" v-on:click="">{{
                            item.label }}
                        </Option>
                    </Select>
                </div>
                <histogram-charts
                    :chartsTitle="'各学校使用排名统计(近一个月数据)'"
                    :isShowMore=false
                    :isClickCharts=false
                    :chartsId="'student_school_rank'"
                    :height="'360px'"
                    :histogramTooltip="'useSecond'"
                    ref="studentSchoolRank"
                ></histogram-charts>
            </Col>
        </Row>
    </div>
</template>
<script>
    import HistogramCharts from "../../../components/charts/HistogramCharts.vue";//柱状图
    import PieCharts from "../../../components/charts/PieCharts.vue";//饼状图
    import LineCharts from "../../../components/charts/LineCharts.vue";//折线图
    import {getStudentCount, getStudentLiveList, getStudentCodingKey,getStudentSchool} from "../../../service/api.js";

    export default {
        name: "student-main",
        data () {
            return {
                student: {
                    // 基础数据
                    schoolCount: 0,
                    studentCount: 0
                },
                dateList: [
                    {
                        value: 1,
                        label: "近一个月数据"
                    }, {
                        value: 2,
                        label: "近三个月数据"
                    }, {
                        value: 3,
                        label: "全部数据"
                    }
                ],
                dateIndex: 1,
                dateText: "近一个月数据"
            };
        },
        components: {
            HistogramCharts,//柱状图组件
            PieCharts,//饼图组件
            LineCharts//折线图
        },
        methods: {

            /**
             * 点击选择时间段
             */
            onChange (val) {
                this.dateIndex = val;
                this.dateText = this.dateList[val - 1].label;
                this.getScreenSchoolUserNum();
            },
            /**
             * 安装大屏的mac数量、大屏学校数量、大屏班级数量、大屏总用户数数据
             */
            async getScreenUseNum () {
                let _this = this;
                await getStudentCount()
                    .then(function (data) {
                        _this.student.schoolCount = data.schoolCount;
                        _this.student.studentCount = data.studentCount;
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取学生机日周月活用户数
             */
            async getHomeWorkLists () {
                let _this = this;
                await getStudentLiveList()
                    .then(function (data) {
                        let dayDataArr = [];
                        let dayNumArr = [];
                        let weekDataArr = [];
                        let weekNumArr = [];
                        let monthDataArr = [];
                        let monthNumArr = [];
                        for (let i = 0; i < data.day.length; i++) {
                            dayDataArr.push(data.day[i].date);
                            dayNumArr.push(data.day[i].number);
                        }
                        for (let i = 0; i < data.week.length; i++) {
                            let strWeekStr = data.week[i].dates.substring(5, 11);
                            let endWeekStr = data.week[i].dates.substring(16);
                            let weekStr = strWeekStr + endWeekStr;
                            weekDataArr.push(weekStr);
                            weekNumArr.push(data.week[i].number);
                        }
                        for (let i = 0; i < data.month.length; i++) {
                            monthDataArr.push(data.month[i].month);
                            monthNumArr.push(data.month[i].userCount);
                        }
                        _this.$nextTick(() => {
                            //渲染日活图表
                            _this.$refs.studentDayUse.initDataSource(data.day, dayDataArr, dayNumArr);
                            //渲染周活图表
                            _this.$refs.studentWeekUse.initDataSource(data.week, weekDataArr, weekNumArr);
                            //渲染月活图表
                            _this.$refs.studentMonthUse.initDataSource(data.month, monthDataArr, monthNumArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取各模块使用统计数据
             */
            async getStudentKey () {
                let _this = this;
                await getStudentCodingKey()
                    .then(function (data) {
                        let list = data;
                        let nameArr = [];
                        let dataArr = [];
                        for (let i = 0; i < list.length; i++) {
                            let obj = {};
                            obj.value = list[i].count;
                            obj.name = list[i].clsName;
                            dataArr.push(obj);
                            nameArr.push(list[i].clsName);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.studentModuleStatics.initDataSource(list, nameArr, dataArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取各学校使用排名统计
             */
            async getScreenSchoolUserNum () {
                let _this = this;
                let params = {
                    type: _this.dateIndex,
                };
                await getStudentSchool(params)
                    .then(function (data) {
                        let schoolList = data;
                        let xDataArr = [];
                        let seriesDataArr = [];
                        for (let i = 0; i < schoolList.length; i++) {
                            xDataArr.push(schoolList[i].school_name);
                            seriesDataArr.push(schoolList[i].count);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.studentSchoolRank.initDataSource(schoolList, xDataArr, seriesDataArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            }
        },
        mounted () {
            this.$store.commit("SET_TOPHEADERNAME", "学生机产品使用统计");
            //安装大屏的mac数量、大屏学校数量、大屏班级数量、大屏总用户数数据
            this.getScreenUseNum();
            //获取学生机日周月活用户数
            this.getHomeWorkLists();
            //获取各模块使用统计数据
            this.getStudentKey();
            //获取各学校使用排名统计
            this.getScreenSchoolUserNum();
        }
    };
</script>

<style lang="scss" scoped>
    @import "../../../style/home";
    /*.mian {*/
    /*margin: 0.5%;*/
    /*}*/
</style>

<style lang="scss">
    .screen-main-cards.screen-main-cards {
        width: 25%;
    }
</style>

